import { z } from 'zod/v4';
import { TableViewFilterSchema } from './table-view-filter';
export const QueryTableViewInputSchema = z.object({
    tableViewId: z.string(),
    filters: z.array(TableViewFilterSchema).nullish(),
});
export const QueryTableViewOutputSchema = z.object({
    columns: z.array(z.object({
        id: z.string(),
        name: z.string(),
        instructions: z.string(),
        type: z.enum([
            'text',
            'date',
            'number',
            'verbatim',
            'options',
            'unknown',
        ]),
        options: z
            .array(z.object({
            id: z.string(),
            value: z.string(),
        }))
            .nullish(),
    })),
    rows: z.array(z.object({
        id: z.string(),
        cells: z.array(z.object({
            columnId: z.string(),
            textValue: z.string().nullish(),
            numberValue: z.number().nullish(),
            dateValue: z.string().nullish(),
            verbatimValue: z.string().nullish(),
            selectedOptions: z
                .array(z.object({
                id: z.string(),
                value: z.string(),
            }))
                .nullish(),
            quote: z.string().nullish(),
            motivation: z.string().nullish(),
        })),
    })),
});
//# sourceMappingURL=query-table-view.js.map